import { FC } from 'react';
import Select from 'react-select';
import { isArray } from 'lodash';
import { useController, useFormContext } from 'react-hook-form';

type Option = { value: string; label: string };

export const GroupsSelectBox = ({ input: inputProps, options }) => (
  <div style={{ width: '400px' }}>
    <Select
      multi
      options={options}
      closeOnSelect={false}
      placeholder="グループ選択"
      name={inputProps.name}
      value={isArray(inputProps.value) && inputProps.value.map(v => options.find(o => o.value === v))}
      noResultsText={'グループがありません'}
      onChange={value => {
        const values = value?.map(v => v.value) || null;
        inputProps.onChange(values);
        inputProps.onBlur(values);
      }}
    />
  </div>
);

interface GroupsSelectBoxControlProps {
  name: string;
  options: Option[];
}

export const GroupsSelectBoxControl: FC<GroupsSelectBoxControlProps> = ({ name, options }) => {
  const { control } = useFormContext();
  const { field } = useController({ name, control });
  return (
    <GroupsSelectBox
      options={options}
      input={{
        value: field.value,
        onChange: field.onChange,
        onBlur: field.onBlur
      }}
    />
  );
};
